<template>
  <div class="booklist">
    <div class="book-wrap" v-for="(book, key) in getBooklist" :key="key">
      <div class="book-img-wrap">
        <img v-on:click="bookSelect(key)" class="book-img" :src="book.image">
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { db } from '@/firebase'

export default {
  data(){
    return {
    }
  },
  components: {
  },
  computed: {
    ...mapGetters([
      'getActiveUserSettings',
      'getBooklist',
      'getUserSettingsLoading'
    ])
  },
  methods: {
    getBooklistFromDb() {
      var tempObj = {}
      const dbConditions = this.getActiveUserSettings.isAdmin ? ['show', 'hide'] : ['show']
      db.collection("booklist")
      .where('display', 'in', dbConditions)
      .get().then((snap) => {
        snap.docs.forEach(doc => {
          tempObj[doc.id] = doc.data()
          this.booklist = tempObj
          this.$store.commit('setBooklist', tempObj)
        })
      })
    },
    bookSelect(firebaseId) {
      var temp = this.getBooklist[firebaseId]
      temp.fireid = firebaseId
      this.$store.commit('setSelectedBook', temp)
      this.$router.replace({ name: "bookinfo" });
    }
  },
  watch: {
    getUserSettingsLoading() {
      if(!this.getUserSettingsLoading) {
        console.log('is not loading (watch)')
        this.getBooklistFromDb()
      } else {
        console.log('is loading (watch)')
      }
    }
  },
  mounted() {
    if(!this.getUserSettingsLoading) {
      console.log('is not loading (Mounted)')
      this.getBooklistFromDb()
    } else {
      console.log('is loading (Mounted)')
    }
  }
}
</script>

<style scoped>
.booklist {
  max-width: 320px;
  margin: 0 auto;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  margin-bottom: 50px;
}:after {
  content: "";
  flex: auto;
} 

.book-img {
  border-radius: 2px;
  transition: transform 0.4s;
  cursor: pointer;
  max-width:140px;
  box-shadow: -4px 5px 14px -4px rgba(0,0,0,0.5);
  margin: 10px;
}

.book-img:hover {
  box-shadow: -4px 5px 14px 0px rgba(0,0,0,0.5);
  transform: scale(1.05);
  transition: transform 0.4s;
}

@media screen and (min-width: 768px) {
  .booklist {
    flex-direction: row;
    max-width: 768px;
    margin: 0 auto;
  }
  .book-img {
    max-width: 150px;
    max-height: 250px;
    margin: 20px;
  }
}

</style>